import { observer } from 'mobx-react';
import { Ready } from '../Types';
import BigNumbers from './BigNumbers';
import LicenseInsights from './LicenseInsights';
import LicenseUsageOverviews from './LicenseUsageOverviews';
import Upsells from './Upsells';

interface Props {
  state: Ready;
}

function Overview({ state }: Props) {
  return (
    <div className="flex w-full justify-between gap-24">
      <div className="flex-grow">
        <BigNumbers state={state} />
        <LicenseUsageOverviews state={state} />
      </div>
      <div className="flex-grow w-2/5">
        <LicenseInsights state={state} />
        <Upsells state={state} />
      </div>
    </div>
  );
}

export default observer(Overview);
